import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right-long",
  "use": "icon-arrow--right-long-usage",
  "viewBox": "0 0 30 31",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 31\" id=\"icon-arrow--right-long\"><path d=\"M25.976 16.164 17.538 24.6a.938.938 0 0 1-1.326-1.326l6.838-6.837H4.687a.937.937 0 1 1 0-1.875H23.05l-6.838-6.837A.938.938 0 0 1 17.538 6.4l8.438 8.437a.94.94 0 0 1 0 1.327Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol